// Add active class to the first accordion item by default
document.addEventListener('DOMContentLoaded', () => {
    // The initial active class is now set by setActive(0) at the end
    // const firstItem = document.querySelector('.accordion-item');
    // firstItem.classList.add('active');
});

// Optional: Add click event listeners to accordion items
// const accordionItems = document.querySelectorAll('.accordion-item'); // This is declared inside DOMContentLoaded now

document.addEventListener('DOMContentLoaded', () => {
    const accordionContainer = document.querySelector('.accordion'); // Get the container
    const accordionItems = document.querySelectorAll('.accordion-item');
    // const progressBars = document.querySelectorAll('.slide-progress-bar'); // Access directly via item
    const carouselDotsContainer = document.querySelector('.carousel-dots'); // Get the dots container
    let currentActiveIndex = 0; // Keep track of the current active index
    let isManualScrolling = false; // Flag to indicate if user is manually scrolling
    // Initially assume visible until scroll checks
    let isAccordionActiveAreaVisible = window.scrollY <= 100;
    let animationStartTime = 0; // Store the time when the animation started for the current slide
    const animationDuration = 7000; // The duration of the progress bar animation in ms

    // Debounce function to limit how often a function is called
    function debounce(func, delay) {
        let timer;
        return function() {
            const context = this;
            const args = arguments;
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(context, args);
            }, delay);
        };
    }

    // Function to reset the progress bar animation for a given item
    function resetProgressBar(item) {
        const progressBar = item.querySelector('.slide-progress-bar');
        if (progressBar) {
            // Ensure transition is off before resetting
            progressBar.style.transition = 'none';
            progressBar.style.width = '0%';
            // Force a reflow to apply the width: 0% immediately
            void progressBar.offsetWidth;
            // Do NOT re-add transition property here, it's added when starting animation
            // progressBar.style.transition = `width ${animationDuration}ms linear`;
             animationStartTime = 0; // Reset start time
             // Remove event listener when resetting
             progressBar.removeEventListener('transitionend', handleProgressComplete);
        }
    }

     // Function to pause the progress bar animation
    function pauseProgressBar(item) {
        const progressBar = item.querySelector('.slide-progress-bar');
        if (progressBar && animationStartTime > 0) { // Only pause if animation has started
            // Calculate elapsed time and the percentage of completion
            const elapsed = performance.now() - animationStartTime;
            const pausedPercentage = (elapsed / animationDuration) * 100;

            // Set transition to none and width to the current completion percentage to pause
            progressBar.style.transition = 'none';
            progressBar.style.width = `${pausedPercentage}%`;

            // Remove the transitionend listener to prevent automatic slide change while paused
            progressBar.removeEventListener('transitionend', handleProgressComplete);
        }
    }

    // Function to resume the progress bar animation
    function resumeProgressBar(item) {
         const progressBar = item.querySelector('.slide-progress-bar');
         // Only resume if it was paused (width is not 0% or 100%) and accordion active area is visible
        if (progressBar && progressBar.style.width !== '0%' && progressBar.style.width !== '100%' && isAccordionActiveAreaVisible) {
            // Get the current completion percentage from the width
            const currentWidth = parseFloat(progressBar.style.width);

            // Calculate the remaining duration based on the current progress
            const remainingDuration = animationDuration * (1 - (currentWidth / 100));

            // Use a small timeout to ensure the transition property is applied before changing width
            setTimeout(() => {
                progressBar.style.transition = `width ${remainingDuration}ms linear`;
                 progressBar.style.width = '100%';
                // Re-add the transitionend listener
                progressBar.addEventListener('transitionend', handleProgressComplete);
                 animationStartTime = performance.now() - (animationDuration * (currentWidth / 100)); // Adjust start time for resuming
            }, 50);
        } else if (progressBar && isAccordionActiveAreaVisible) {
             // If it was at 0% or 100% when it became visible, restart the animation from the beginning
             // This scenario might occur if the slide changed while the accordion was invisible
             startProgressBar(item);
        }
    }

    // Function to start the progress bar animation for a given item
    function startProgressBar(item) {
         const progressBar = item.querySelector('.slide-progress-bar');
        if (progressBar && isAccordionActiveAreaVisible) {
            // Ensure transition is off initially
            progressBar.style.transition = 'none';
            progressBar.style.width = '0%';
            void progressBar.offsetWidth; // Force reflow

            // Add listener BEFORE starting the transition
            // Remove existing first to prevent duplicates
            progressBar.removeEventListener('transitionend', handleProgressComplete);
            progressBar.addEventListener('transitionend', handleProgressComplete);

            // Start the transition after a small delay
            animationStartTime = performance.now(); // Record start time
            setTimeout(() => {
                progressBar.style.transition = `width ${animationDuration}ms linear`;
                progressBar.style.width = '100%';
            }, 50);
        }
    }

   

    // Handler for when the progress bar animation completes
    function handleProgressComplete(event) {
        // Check if the transition is for the width property and on a progress bar
        if (event.propertyName === 'width' && event.target.classList.contains('slide-progress-bar')) {
            // Find the index of the item whose progress bar just completed
            const completedProgressBar = event.target;
            const completedItem = completedProgressBar.closest('.accordion-item');
            // Use Array.from and indexOf to reliably get the index
            const currentIndex = Array.from(accordionItems).indexOf(completedItem);

            // Calculate the next index
            const nextIndex = (currentIndex + 1) % accordionItems.length;

             // Only proceed to the next slide if the accordion active area is currently visible
             if (isAccordionActiveAreaVisible) {
                // Set the next item as active with smooth scrolling
                 setActive(nextIndex, 'smooth');
             } else {
                 // If not visible, just update the current active index and reset the next slide's progress
                 currentActiveIndex = nextIndex;
                 resetProgressBar(accordionItems[nextIndex]);
             }
        }
    }

    // Function to find the most visible item after scrolling stops
    const findMostVisibleItem = debounce(() => {
        if (isManualScrolling) {
            let mostVisibleIndex = -1;
            let minDistance = Infinity;

            const containerRect = accordionContainer.getBoundingClientRect();
            const containerCenter = containerRect.left + containerRect.width / 2;

            accordionItems.forEach((item, index) => {
                const itemRect = item.getBoundingClientRect();
                const itemCenter = itemRect.left + itemRect.width / 2;
                const distance = Math.abs(itemCenter - containerCenter);

                if (distance < minDistance) {
                    minDistance = distance;
                    mostVisibleIndex = index;
                }
            });

            // Set the most visible item as active
            if (mostVisibleIndex !== -1 && mostVisibleIndex !== currentActiveIndex) {
                // Simulate click on the most visible item
                accordionItems[mostVisibleIndex].click();
            }
            isManualScrolling = false;
        }
    }, 150);

    // Add scroll event listener to the accordion container for manual scrolling
    accordionContainer.addEventListener('scroll', () => {
        isManualScrolling = true;
        findMostVisibleItem();
    });

    // Add scroll event listener to the window to check scroll position and handle manual scrolling
    window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY || document.documentElement.scrollTop;
        const wasAccordionActiveAreaVisible = isAccordionActiveAreaVisible; // Store previous state

        // Update current visibility state based on 100px scroll
        isAccordionActiveAreaVisible = currentScrollY <= 100;

        // If accordion active area just became invisible, pause the current slide's progress
        if (wasAccordionActiveAreaVisible && !isAccordionActiveAreaVisible) {
             const currentActiveItem = accordionItems[currentActiveIndex];
            if (currentActiveItem) {
                 pauseProgressBar(currentActiveItem);
             }
        }

        // If accordion active area just became visible, resume the current slide's progress
        // Only attempt to resume if it was previously invisible
        if (!wasAccordionActiveAreaVisible && isAccordionActiveAreaVisible) {
            const currentActiveItem = accordionItems[currentActiveIndex];
             if (currentActiveItem) {
                 resumeProgressBar(currentActiveItem);
             }
        }

        // Handle manual scrolling for snapping to the closest item when visible
        // Use findMostVisibleItem with debounce for this
        isManualScrolling = true; // Assume any window scroll might be manual scrolling of the accordion
        findMostVisibleItem(); // Debounced function to find and activate the most visible item
    });

    // Function to create navigation dots (Assuming this is still needed)
    function createNavigationDots() {
        if (!carouselDotsContainer) return; // Ensure the container exists
        carouselDotsContainer.innerHTML = ''; // Clear existing dots
        accordionItems.forEach((_, index) => {
            const dot = document.createElement('div');
            dot.classList.add('dot');
            dot.addEventListener('click', () => {
                setActive(index, 'smooth'); // Set active and scroll to the clicked item
            });
            carouselDotsContainer.appendChild(dot);
        });
    }


    // Add click event listeners to each accordion item
    accordionItems.forEach((item, index) => {
        item.addEventListener('click', () => {
            // Stop the current progress bar animation and start the new one
            // Use smooth scrolling when clicking
            setActive(index, 'smooth');
        });
    });

    // Initialize the navigation dots
    createNavigationDots();

    // Set the first item as active on page load to start the process
    if (accordionItems.length > 0) {
        // Determine initial visibility on load
        const currentScrollY = window.scrollY || document.documentElement.scrollTop;
        isAccordionActiveAreaVisible = currentScrollY <= 100;

        // setActive(0, 'instant'); // Set the first item as active initially
        // The startProgressBar function within setActive will handle starting the animation if visible
    }
});


// Dunplicate content JS

function injectMobileSections() {
  const viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  if (viewportWidth < 992) {
    const sectionGroups = [
      { desktopPrefix: 'desktop-section', mobilePrefix: 'mobile-section' },
      { desktopPrefix: 'new-desktop-section', mobilePrefix: 'new-mobile-section' },
      { desktopPrefix: 'new1-desktop-section', mobilePrefix: 'new1-mobile-section' },
      { desktopPrefix: 'new2-desktop-section', mobilePrefix: 'new2-mobile-section' },
      { desktopPrefix: 'dp-desktop-section', mobilePrefix: 'dp-mobile-section' },
      { desktopPrefix: 'case-study-desktop', mobilePrefix: 'case-study-mobile' },
      { desktopPrefix: 'blog-desktop', mobilePrefix: 'blog-mobile' }
    ];

    sectionGroups.forEach(group => {
      for (let i = 1; i <= 8; i++) {
        const desktopSection = document.getElementById(`${group.desktopPrefix}-${i}`);
        const mobileSection = document.getElementById(`${group.mobilePrefix}-${i}`);

        if (desktopSection && mobileSection && mobileSection.innerHTML.trim() === '') {
          mobileSection.innerHTML = desktopSection.innerHTML;
        }
      }
    });
  }
}

// Copy testimonial script

document.addEventListener('DOMContentLoaded', injectMobileSections);
window.addEventListener('resize', injectMobileSections);

document.addEventListener('DOMContentLoaded', () => {
  const allDupIds = new Set();
  document.querySelectorAll('[data-dup-id]').forEach(el => {
    allDupIds.add(el.getAttribute('data-dup-id'));
  });

  allDupIds.forEach(dupId => {
    const original = document.querySelector(`#${dupId}`);
    if (original) {
      const duplicates = document.querySelectorAll(`[data-dup-id="${dupId}"]:not(#${dupId})`);
      duplicates.forEach(dup => {
        dup.innerHTML = original.innerHTML;
      });
    }
  });
});

window.addEventListener('load', () => {
  document.querySelectorAll('[data-dup-id]').forEach(dup => {
    const id = dup.getAttribute('data-dup-id');
    const original = document.getElementById(id);
    if (original && original !== dup && original.innerHTML.trim() !== '') {
      dup.innerHTML = original.innerHTML;
    }
  });
});


function copyDuplicateContent(attempt = 0) {
  const maxAttempts = 10;
  const delay = 200; // ms

  let allReady = true;

  document.querySelectorAll('[data-dup-id]').forEach(dup => {
    const id = dup.getAttribute('data-dup-id');
    const original = document.getElementById(id);

    if (original && original !== dup && original.innerHTML.trim() !== '') {
      dup.innerHTML = original.innerHTML;
    } else {
      allReady = false;
    }
  });

  if (!allReady && attempt < maxAttempts) {
    setTimeout(() => copyDuplicateContent(attempt + 1), delay);
  }
}

window.addEventListener('load', () => {
  copyDuplicateContent();
});

// Dunplicate content End JS


// Video playback functionality



document.addEventListener('DOMContentLoaded', function() {
    const videoContainers = document.querySelectorAll('.video-container');
    
    // Function to pause all videos except the one being played
    function pauseOtherVideos(currentVideo) {
        videoContainers.forEach(container => {
            const video = container.querySelector('video.testimonial-video-iframe');
            if (video && video !== currentVideo) {
                video.pause();
                video.muted = true;
                // Show the play button and thumbnail again
                const playButton = container.querySelector('.play-button');
                const thumbnail = container.querySelector('.video-thumbnail');
                if (playButton) playButton.style.display = 'flex';
                if (thumbnail) thumbnail.style.display = 'block';
            }
        });
    }
    
    videoContainers.forEach(container => {
        const playButton = container.querySelector('.play-button');
        const video = container.querySelector('video.testimonial-video-iframe');
        const thumbnail = container.querySelector('.video-thumbnail');
        
        // Prevent clicks on the container from doing anything
        container.addEventListener('click', function(event) {
            // Only prevent default if the target is NOT the play button
            if (!event.target.closest('.play-button')) {
                 event.preventDefault();
                 event.stopPropagation();
            }
        });

        // Prevent clicks on the video itself from doing anything
        if (video) {
            video.addEventListener('click', function(event) {
                 event.preventDefault();
                 event.stopPropagation();
            });
        }

        if (playButton && video) {
            playButton.addEventListener('click', function() {
                // Pause all other videos first
                pauseOtherVideos(video);
                
                // Hide thumbnail if it exists
                if (thumbnail) {
                    thumbnail.style.display = 'none';
                }
                
                // Hide play button
                playButton.style.display = 'none';
                
                // Show and play the video
                video.style.display = 'block';
                video.muted = false;
                video.play().catch(function(error) {
                    console.log("Video play failed:", error);
                });
            });

            // Add event listener for when video ends
            video.addEventListener('ended', function() {
                // Reset the video container state
                if (thumbnail) thumbnail.style.display = 'block';
                playButton.style.display = 'flex';
                video.style.display = 'none'; // Ensure video is hidden
                video.muted = true;
                video.currentTime = 0; // Reset video to the beginning
            });
        }
    });
});

// Goto top script

const goToTopBtn = document.getElementById("goToTopBtn");

        window.onscroll = function() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                goToTopBtn.style.display = "block";
            } else {
                goToTopBtn.style.display = "none";
            }
        };

        goToTopBtn.addEventListener("click", function() {
            window.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        });

// --- Navbar Dropdown Hover & Click Fix ---

document.addEventListener('DOMContentLoaded', function () {
  function bindHoverDropdowns() {
    if (window.innerWidth > 992) {
      document.querySelectorAll('.mega-dropdown').forEach(function (dropdown) {
        const menu = dropdown.querySelector('.dropdown-menu');
        if (!menu) return;

        let timeout;

        function showMenu() {
          clearTimeout(timeout);
          dropdown.classList.add('show');
          menu.classList.add('show');
        }

        function hideMenu() {
          timeout = setTimeout(function () {
            dropdown.classList.remove('show');
            menu.classList.remove('show');
          }, 150);
        }

        dropdown.addEventListener('mouseenter', showMenu);
        dropdown.addEventListener('mouseleave', hideMenu);
        menu.addEventListener('mouseenter', showMenu);
        menu.addEventListener('mouseleave', hideMenu);
      });
    }
  }

  bindHoverDropdowns(); // Run once on page load
});





// video carousel slider js
window.addEventListener('load', () => {
  const el = document.getElementById('newTopCarousel');
  if (!el || typeof bootstrap === 'undefined') return;

  const carousel = new bootstrap.Carousel(el, {
    interval: false,
    touch: true,
    wrap: true
  });

  let startX = 0, endX = 0, dragging = false;

  const handleSwipe = () => {
    const diff = endX - startX;
    if (diff > 50) carousel.prev();
    if (diff < -50) carousel.next();
  };

  const start = e => startX = e.touches ? e.touches[0].screenX : e.screenX;
  const move = e => {
    if (!dragging) return;
    if (!e.touches) endX = e.screenX;
  };
  const end = e => {
    endX = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
    handleSwipe();
    dragging = false;
  };

  el.addEventListener('touchstart', start);
  el.addEventListener('touchend', end);
  el.addEventListener('mousedown', e => { dragging = true; start(e); });
  el.addEventListener('mousemove', move);
  el.addEventListener('mouseup', end);
  el.addEventListener('dragstart', e => e.preventDefault());
});


// Page under development script

document.addEventListener('DOMContentLoaded', function () {
    window.showComingSoon = function (service) {
        alert(`${service} Page is under development.\nContact us for more information!`);
    }
});



// scroll hide top bar script

// topbar-toggle.js
document.addEventListener('DOMContentLoaded', function () {
    const topBar = document.getElementById('top-bar');

    window.addEventListener('scroll', function () {
        const scrollY = window.scrollY || document.documentElement.scrollTop;

        if (scrollY > 100) {
            topBar.style.display = "none";
        } else if (scrollY === 0) {
            topBar.style.display = "block";
        }
    });
});








document.addEventListener("DOMContentLoaded", function () {

    function initMegaMenu() {
        console.log("MegaMenu Initializing... Width: " + window.innerWidth);

        if (window.innerWidth < 1200) return;

        const header = document.querySelector(".myheader");
        const megaItems = document.querySelectorAll(".mega-dropdown");

        function closeAll() {
            megaItems.forEach(item => {
                item.classList.remove("show");
                const menu = item.querySelector(".dropdown-menu");
                if (menu) {
                    menu.classList.remove("show");
                    menu.style.display = "none";
                    menu.style.opacity = "0";
                }
            });
        }

        megaItems.forEach(item => {
            if (item.dataset.bound) return;
            item.dataset.bound = "true";

            const link = item.querySelector('a');

            const openThis = () => {
                console.log("Hover detected! Opening menu...");
                megaItems.forEach(other => {
                    if (other !== item) {
                        other.classList.remove("show");
                        const otherMenu = other.querySelector(".dropdown-menu");
                        if (otherMenu) {
                            otherMenu.classList.remove("show");
                            otherMenu.style.display = "none";
                        }
                    }
                });

                item.classList.add("show");
                const menu = item.querySelector(".dropdown-menu");
                if (menu) {
                    menu.classList.add("show");
                    menu.style.display = "block";
                    menu.style.opacity = "1";
                    menu.style.visibility = "visible";
                }
            };

            item.addEventListener("mouseenter", openThis);
            if (link) {
                link.addEventListener("mouseenter", (e) => {
                    e.stopPropagation();
                    openThis();
                });
            }
        });

        if (header && !header.dataset.bound) {
            header.dataset.bound = "true";
            header.addEventListener("mouseleave", closeAll);
        }
    }

    initMegaMenu();
    // Re-run after 500ms to catch any late-loading live elements
    setTimeout(initMegaMenu, 500); 

    let resizeTimer;
    window.addEventListener("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initMegaMenu, 200);
    });
});
